import React, { useEffect } from 'react';
import { Card, CardBody, CardHeader, Button, Table } from 'reactstrap';
import { FieldArray } from 'formik';
import { TablesWithoutBorders } from "../../pages/Tables/BasicTables/BasicTablesCode";
import { Link } from "react-router-dom";
import InputField from '../Utils/InputField';

export default function Attribute({
  values,
  touched,
  errors,
  handleChange,
  setTouched,
  handleChangeForAttributeValue,
  isEmptyOrInvalidField,
  deviceID,
  isEdit,
  setFieldValue
}) {
  const handleClearCurrentRow = (index) => {
    setFieldValue(`attributeList[${index}].rangeEnds`, '');
    setFieldValue(`attributeList[${index}].statusLabel`, '');

    setTouched({
      ...touched,
      attributeList: {
        ...touched.attributeList,
        [index]: {
          type: false,
          name: false,
          value: false,
        },
      },
    });
  };
  useEffect(() => {
    values.attributeList.forEach((attr, index) => {
      if (attr.rangeEnds !== "" && values.attributeList[index + 1]) {
        const expectedNextRangeStart = parseInt(attr.rangeEnds, 10) + 1;
        const currentNextRangeStart = parseInt(values.attributeList[index + 1].rangeStarts, 10);
        if (currentNextRangeStart !== expectedNextRangeStart) {
          setFieldValue(`attributeList[${index + 1}].rangeStarts`, expectedNextRangeStart.toString());
        }
      }
    });
  }, [values.attributeList, setFieldValue]);
  return (
    <FieldArray name="attributeList">
      {({ push, remove }) => (
        <div>
          <h4 className="card-title mb-0 flex-grow-1">Rules</h4>
          {/* <Button
              color="secondary"
              className="btn-label"
              onClick={() => {
                const lastIndex = values.attributeList.length - 1;
                if (lastIndex === -1 || !isEmptyOrInvalidField(lastIndex, values)) {
                  const newRangeStarts = lastIndex === -1 ? (0).toString(): (parseInt(values.attributeList[lastIndex].rangeEnds, 10) + 1).toString();
                  push({ rangeStarts: newRangeStarts, rangeEnds: "", statusLabel: "" });
                  setTouched({
                    ...touched,
                    attributeList: {
                      ...touched.attributeList,
                      [lastIndex + 1]: {
                        rangeStarts: false,
                        rangeEnds: false,
                        statusLabel: false
                      },
                    },
                  });
                }
              }}
            >
              <i className="ri-add-fill label-icon align-middle fs-16 me-2"></i> Add Rule
            </Button> */}
          <CardBody>
            {/* <div className="live-preview"> */}
            {/* <div className="table-responsive"> */}
            <div className="scrollable-view">
              <Table className="table-borderless align-middle table-nowrap ms-0 mb-0 overflow-auto">
                <thead>
                  <tr>
                    <th className="px-0 mx-0" scope="col">Range Starts<span className="text-danger">*</span></th>
                    <th scope="px-0 mx-0">Range Ends<span className="text-danger">*</span></th>
                    <th scope="px-0 mx-0">Status Label<span className="text-danger">*</span></th>
                    <th scope="px-0 mx-0"></th>
                  </tr>
                </thead>
                <tbody>
                  {values.attributeList && (
                    values.attributeList.map((val, index) => (
                      (
                        <tr key={index}>
                          <td className="w-xl px-0 mx-0">
                            <InputField
                              name={`attributeList[${index}].rangeStarts`}

                              className={
                                (touched.attributeList &&
                                  touched.attributeList[index] &&
                                  errors.attributeList &&
                                  errors.attributeList[index] &&
                                  touched.attributeList[index].rangeStarts)
                                  ? "is-invalid"
                                  : ""
                              }
                              placeholder="Enter Range Starts"
                              type="text"
                              handleChange={handleChangeForAttributeValue(handleChange)}
                              value={values.attributeList[index].rangeStarts || ""}
                              disabled={true}
                              invalid={
                                errors.attributeList &&
                                  errors.attributeList[index] &&
                                  touched.attributeList &&
                                  touched.attributeList[index] &&
                                  errors.attributeList[index].rangeStarts
                                  ? true
                                  : false
                              }
                              readOnly
                            />
                            {/* {errors.attributeList &&
                            errors.attributeList[index] &&
                            touched.attributeList &&
                            touched.attributeList[index] &&
                            touched.attributeList[index].rangeStarts && (
                              <p className="text-danger">
                                {errors.attributeList[index].rangeStarts}
                              </p>
                            )} */}
                          </td>
                          <td className="w-xl">
                            <InputField
                              name={`attributeList[${index}].rangeEnds`}
                              className={
                                (touched.attributeList &&
                                  touched.attributeList[index] &&
                                  errors.attributeList &&
                                  errors.attributeList[index] &&
                                  touched.attributeList[index].rangeEnds)
                                  ? "is-invalid"
                                  : ""
                              }
                              placeholder="Enter Range Ends"
                              type="number"
                              handleChange={handleChangeForAttributeValue(handleChange)}
                              value={values.attributeList[index].rangeEnds || ""}
                              invalid={
                                errors.attributeList &&
                                  errors.attributeList[index] &&
                                  touched.attributeList &&
                                  touched.attributeList[index] &&
                                  errors.attributeList[index].rangeEnds
                                  ? true
                                  : false
                              }
                            />
                            {/* {errors.attributeList &&
                            errors.attributeList[index] &&
                            touched.attributeList &&
                            touched.attributeList[index] &&
                            touched.attributeList[index].rangeEnds && (
                              <p className="text-danger">
                                {errors.attributeList[index].rangeEnds}
                              </p>
                            )} */}
                          </td>
                          <td className="w-xl">
                            <InputField
                              name={`attributeList[${index}].statusLabel`}
                              className={
                                (touched.attributeList &&
                                  touched.attributeList[index] &&
                                  errors.attributeList &&
                                  errors.attributeList[index] &&
                                  touched.attributeList[index].statusLabel)
                                  ? "is-invalid"
                                  : ""
                              }
                              placeholder="Enter Status Label"
                              type="text"
                              handleChange={handleChangeForAttributeValue(handleChange)}
                              value={values.attributeList[index].statusLabel || ""}
                              invalid={
                                errors.attributeList &&
                                  errors.attributeList[index] &&
                                  touched.attributeList &&
                                  touched.attributeList[index] &&
                                  errors.attributeList[index].statusLabel
                                  ? true
                                  : false
                              }
                            />
                            {/* {errors.attributeList &&
                            errors.attributeList[index] &&
                            touched.attributeList &&
                            touched.attributeList[index] &&
                            touched.attributeList[index].statusLabel && (
                              <p className="text-danger">
                                {errors.attributeList[index].statusLabel}
                              </p>
                            )} */}
                          </td>
                          {!deviceID[index] && (
                            <td className="w-xl">
                              <div className="d-flex align-items-center flex-row gap-2">
                                <>
                                  {!isEmptyOrInvalidField(index, values) && index === 0 && (
                                    <div className="d-flex align-items-center flex-row gap-2">
                                      <i
                                        className="mdi mdi-plus-circle-outline fs-5 text-primary me-1"
                                        role="button"
                                        onClick={() => {
                                          const lastIndex = values.attributeList.length - 1;
                                          if (lastIndex === -1 || !isEmptyOrInvalidField(lastIndex, values)) {
                                            const newRangeStarts = lastIndex === -1 ? (0).toString() : (parseInt(values.attributeList[lastIndex].rangeEnds, 10) + 1).toString();
                                            push({ rangeStarts: newRangeStarts, rangeEnds: "", statusLabel: "" });
                                            setTouched({
                                              ...touched,
                                              attributeList: {
                                                ...touched.attributeList,
                                                [lastIndex + 1]: {
                                                  rangeStarts: false,
                                                  rangeEnds: false,
                                                  statusLabel: false
                                                },
                                              },
                                            });
                                          }
                                        }}
                                      ></i>
                                      <div>
                                        <i
                                          className="ri-close-line fw-bold align-middle fs-4 cross-icon-color"
                                          role="button"
                                          onClick={() => {
                                            handleClearCurrentRow(index)
                                          }}
                                        ></i>
                                      </div>
                                    </div>)}
                                  {(index !== 0) &&
                                    <Link
                                      to="#"
                                      className="link-danger fs-5"
                                      onClick={() => {
                                        remove(index);
                                        if (values.attributeList.length === 1) {
                                          handleClearCurrentRow(0)
                                        }
                                      }}
                                    >
                                      <i
                                        data-testid="delete"
                                        className="ri-delete-bin-5-line"
                                      ></i>
                                    </Link>
                                  }
                                </>
                              </div>
                            </td>
                          )}
                          {/* {!deviceID[index] && (
                          <td>
                            <div className="d-flex align-items-center gap-2">
                              {isCurrentRowFilled(index, values) && (
                                <>
                                  <div>
                                    <i
                                      className="mdi mdi-plus-circle-outline fs-5 text-primary me-1"
                                      role="button"
                                      onClick={() => handleAddAttribute(push)}
                                    ></i>
                                  </div>


                                  <i className="ri-close-line fw-bold align-middle fs-4 cross-icon-color"
                                    role="button"
                                    onClick={() => handleClearCurrentRow(index)}
                                  ></i>

                                </>
                              )}

                              {index > 0 && !isCurrentRowFilled && (
                                <Link
                                  to="#"
                                  className="link-danger fs-5"
                                  onClick={() => {
                                    remove(index);
                                    if (attributeList.length === 1) {
                                      initializeDefaultRow();
                                    }
                                  }}
                                >
                                  <i
                                    data-testid="delete"
                                    className="ri-delete-bin-5-line"
                                  ></i>
                                </Link>
                              )}
                            </div>
                            <div className="hstack gap-3 fs-15">
                              <Link
                                to="#"
                                className="link-danger"
                                onClick={() => remove(index)}
                              >
                                <i data-testid="delete" className="ri-delete-bin-5-line"></i>
                              </Link>
                            </div>
                          </td>
                        )} */}
                        </tr>
                      )
                    ))
                  )}
                </tbody>
              </Table>
              <div className="d-none code-view">
                <pre className="language-markup default-height">
                  <code>
                    <TablesWithoutBorders />
                  </code>
                </pre>
              </div>
            </div>
          </CardBody>
        </div>
      )}

    </FieldArray>
  );
}